module.exports = __webpack_public_path__ + "static/sponsorship_img3M@2x-7bf0bc3d5e72ca390168e1fa31846fd3.jpg";